import React from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const datosCorreo = (message) => {
  if (!message?.dataJson) return null;
  try {
    const d = typeof message.dataJson === "string" ? JSON.parse(message.dataJson) : message.dataJson;
    return d?.email || null;
  } catch {
    return null;
  }
};

/** «Re: Fwd: RV: Pedido» y «pedido» son el mismo hilo. */
const tema = (s) => String(s || "").replace(/^\s*((re|fwd?|rv|res|enc|aw|wg)\s*(\[\d+\])?\s*:\s*)+/i, "").trim().toLowerCase();

/**
 * Asunto de un correo (doc 0445 E4.5), solo cuando abre un hilo o lo cambia: un ticket de correo se lee
 * como una conversación, no como una bandeja con el asunto repetido en cada respuesta. Los adjuntos
 * van en mensajes aparte y nunca lo llevan.
 */
export const asuntoVisible = (message, index, messages) => {
  const e = datosCorreo(message);
  if (!e?.subject || e.attachment) return null;
  for (let i = (index ?? 0) - 1; i >= 0 && messages; i--) {
    const previo = datosCorreo(messages[i]);
    if (previo?.subject && !previo.attachment) return tema(previo.subject) === tema(e.subject) ? null : e.subject;
  }
  return e.subject;
};

const EmailSubject = ({ subject }) =>
  subject ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontWeight: 600,
        fontSize: 13,
        paddingBottom: 4,
        marginBottom: 4,
        borderBottom: "1px solid rgba(127,127,127,0.25)",
        paddingRight: 28,
      }}
    >
      <MailOutlineIcon style={{ fontSize: 15, opacity: 0.7 }} />
      <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{subject}</span>
    </div>
  ) : null;

export default EmailSubject;
